import UDSTLogo from '../images/TetherLogo.svg'
import USDCLogo from '../images/USDCLogo.svg'
import BTCLogo from '../images/BTCLogo.svg'
import BATLogo from '../images/BAT.svg'
import BUSDLogo from '../images/BUSDLogo.svg'

export interface Token {
  name: string
  ticker: string
  logo: string
  addresses: { [key: number]: string }
  decimals: { [key: number | string]: number }
}

export const Tokens: Record<string, Token> = {
  BTC: {
    name: 'Bitcoin',
    ticker: 'BTC',
    addresses: {},
    logo: BTCLogo as string,
    decimals: {
      default: 8
    }

  },
  USDC: {
    name: 'USD Coin',
    ticker: 'USDC',
    logo: USDCLogo as string,
    addresses: {
      1: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
      31337: '0x6d4cc59Ca95Ab85e333a17bAF97a225CA10F292c',
      5: '0x12437ca9aCb41Cc73D1c59E29C7496A054FC8A78',
      80001: '0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F',
      4002: '0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc',
      11155111: '0xa4fCE8264370437e718aE207805b4e6233638b9E',
      1313161555: '0x0C6013dfdaBF883F3fc2d7D9911f30f54D10E4a6',
      43113: '0x2e9B1F01068B96D7c85913f70Cf29464FA98b567',
      534353: '0x87cba17033bAA29324708dC12503a14C179a00D7',
      137: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
      56: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
      250: '0x04068DA6C83AFCFA0e13ba15A6696662335D5B75',
      43114: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
      66: '0xc946DAf81b08146B1C7A8Da2A851Ddf2B3EAaf85'
    },
    decimals: {
      default: 6,
      56: 18,
      66: 18
    }
  },
  USDT: {
    name: 'Tether USD',
    ticker: 'USDT',
    addresses: {
      1: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      31337: '0x7e05775C8CD424Fc80a0a6B31c7596fdF20B8076',
      5: '0x1AAaF0f10C26E33DBe04d06531E533345CbA755e',
      80001: '0x70BE8802e2F3C6652B7e0814B478f66Ec52d9d88',
      4002: '0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88',
      11155111: '0xE50d86c6dE38F9754f6777d2925377564Bf79482',
      1313161555: '0x7696c118ea37866c38918CAE97C4A9383e8129F6',
      43113: '0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc',
      534353: '0xA0CA2CdC4291826AAFb0C2DF77f303EdfeA34ef3',
      137: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
      56: '0x55d398326f99059ff775485246999027b3197955',
      43114: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
      66: '0x382bB369d343125BfB2117af9c149795C6C65C50'
    },
    logo: UDSTLogo as string,
    decimals: {
      default: 6,
      56: 18,
      66: 18
    }
  },
  BUSD: {
    name: 'Binance USD',
    ticker: 'BUSD',
    addresses: {
      56: '0xe9e7cea3dedca5984780bafc599bd69add087d56'
    },
    logo: BUSDLogo as string,
    decimals: {
      default: 18
    }
  },
  BAT: {
    name: 'Basic Attention Token',
    ticker: 'BAT',
    addresses: {
      1: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
      137: '0x3cef98bb43d732e2f285ee605a8158cde967d219',
      56: '0x101d82428437127bf1608f699cd651e6abf9766e',
      80001: '0xd445cAAbb9eA6685D3A512439256866563a16E93',
      4002: '0x5720755857EF377D59cb8758B5E3eDBC483b4467',
      11155111: '0x5D684d37922dAf7Aa2013E65A22880a11C475e25',
      1313161555: '0x8dEf8ef4ea453c4dd988c1596DD6FaDD6A291e53',
      43113: '0xABB6a5C05a70098585D095D5446b6845b57E2873'
    },
    logo: BATLogo as string,
    decimals: {
      default: 18
    }
  }
}
